import { addressClient } from "@core/clients";
import { Address, AddressInput, User } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "../../config/query-client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

type Payload = {
  customerId: User["id"];
  customerAddressInput: AddressInput;
};

type Options = UseMutationOptions<Address | null, unknown, Payload, string[]>;

const useCreateCustomerAddress = (options?: Options) => {
  const { t } = useTranslation();
  return useMutation(
    ["customer-address", "create"],
    async ({ customerAddressInput, customerId }) => {
      return addressClient.createCustomerAddress(customerAddressInput, customerId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["customer-address", "get"]);
      },
      onError: (error: any) => {
        if (error?.message?.includes("unique_customer_address")) {
          toast.error(t("This address already exist"));
        } else {
          console.log("error", error?.message);
        }
      }, 
      ...options,
    }
  );
};

export default useCreateCustomerAddress;
